module.exports = __webpack_public_path__ + "static/img/n2.d17079c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/resourceShow/img/zh/n2.png
// module id = E0rw
// module chunks = 3